// ClaimCapDrawer's read and write (finance-real, the user 2026-10-22): the ceiling it opens on, and saving a new one, which
// the drawer hands its form.
import type { UseMutationResult, UseQueryResult } from "@tanstack/react-query";
import { useClaimSettings, useSetClaimSettings } from "../../hooks/useJobClaims";
import type { ClaimSettings } from "../../types";

export interface ClaimCapDrawerModel {
  settings: UseQueryResult<ClaimSettings>;
  save: UseMutationResult<ClaimSettings, Error, ClaimSettings>;
}

export function useClaimCapDrawer(): ClaimCapDrawerModel {
  const settings = useClaimSettings();
  const save = useSetClaimSettings();
  return { settings, save };
}
